module.exports = __webpack_public_path__ + "img/DKK_Bierflasche_192992202_02.785deead.jpg";